import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import CloseIcon from "../../assets/images/close.png";

import { connect } from "react-redux";
import { compose } from "redux";

import { Disable } from 'react-disable';
import debounce from "lodash/debounce";

import { updateDepartment, addProcedure, addAttachment, editProcedure, getProcedures } from "../../store/actions/departmentActions";

import Select from 'react-select'




const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#3b3b3b' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #3b3b3b' : 'none',
        '&:hover': {
            borderColor: '#3b3b3b',
        },
        backgroundColor: '#EEF0ED',
        padding: 1,
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 999999999999, // Ensures the menu appears above other elements
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#3b3b3b' : state.isFocused ? '#EEF0ED' : 'white',
        color: state.isSelected ? 'white' : '#3b3b3b',
        '&:hover': {
            backgroundColor: '#EEF0ED',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#3b3b3b',
    }),
};


const probabilityOption = (props) => {
    const { innerRef, innerProps, data } = props;
    return (
        <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center', padding: 10 }}>
            <div style={{ width: 20, height: 20, marginRight: 10, backgroundColor: data.color, color: data.color, borderRadius: 5 }} />
            {data.label}
        </div>
    );
};

const probabilitySingleValue = (props) => {
    const { data } = props;
    return (
        <div style={{ display: 'flex', alignItems: 'center', padding: 0 }}>
            <div style={{ width: 10, height: 10, marginRight: 5, backgroundColor: data.color, color: data.color, borderRadius: 5 }} />
            {data.label === "Almost Certain" || data.label === "Catastrophe" || data.label === "Not started" ? `${data.label.substring(0, 7)}...` : data.label}
        </div>
    );
};


const DepartmentOverlay = ({ close, department, edit, updateDepartmentFN, department_redux, addProcedureFN, addAttachmentFN, editProcedureFN, getProceduresFN }) => {

    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState(false);

    const listRiskAppetites = useMemo(
        () =>
            [
                { value: "Averse", color: "#0081A7" },
                { value: "Minimalist", color: "#00AFB9" },
                { value: "Cautious", color: "#FED9B7" },
                { value: "Open", color: "#D6606E" },
                { value: "Hungry", color: "#BB133E" },
            ].map((x) => ({
                ...x,
                label: t(`riskCenterPortal.enums.riskAppetite.${x.value}`),
            })),
        [t]
    );

    const department_colors = useMemo(
        () =>
            [
                { value: "#FF5733", colorKey: "redOrange", color: "#FF5733" },
                { value: "#33FF57", colorKey: "green", color: "#33FF57" },
                { value: "#3357FF", colorKey: "blue", color: "#3357FF" },
                { value: "#F1C40F", colorKey: "yellow", color: "#F1C40F" },
                { value: "#8E44AD", colorKey: "purple", color: "#8E44AD" },
                { value: "#E67E22", colorKey: "carrot", color: "#E67E22" },
                { value: "#2ECC71", colorKey: "emerald", color: "#2ECC71" },
                { value: "#3498DB", colorKey: "peterRiver", color: "#3498DB" },
                { value: "#9B59B6", colorKey: "amethyst", color: "#9B59B6" },
                { value: "#34495E", colorKey: "wetAsphalt", color: "#34495E" },
            ].map((x) => ({
                value: x.value,
                color: x.color,
                label: t(`riskCenterPortal.enums.color.${x.colorKey}`),
            })),
        [t]
    );
    const [policies, setPolicies] = useState([]);

    const [formControlState, setFormControlState] = useState([]);

    const [currentPolicy, setCurrentPolicy] = useState(null);
    const fileInputRef = React.useRef(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && currentPolicy) {
            //setAddedNew(true);
            addAttachmentFN(department.department_id, currentPolicy.policy_id, file);
        }
    };


    const handleAttachmentClick = (policy) => {

        setCurrentPolicy(policy);

        ////////console.log(policy);
        if (policy.policy_attachment) {
            window.open(policy.policy_attachment, '_blank');
        } else {
            if (fileInputRef.current) {
                fileInputRef.current.click();
            }
        }
    };


    const [formState, setFormState] = useState({
        name: department ? department.name : '',
        definition: department ? department.definition : '',
        personnel_number: department ? department.personnel_number : '',
        risk_appetite: department ? department.risk_appetite : '',
        location: department ? department.location : '',
        color: department ? department.color : '',
        comments: '',
        company_id: null,
        framework: department ? (department.framework ? department.framework : 0) : 0,
    });





    useEffect(() => {
        ////console.log("department ", department)
        if (department) {
            setPolicies([]);
            getProceduresFN(department.department_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (department?.company_id) {
            setFormState(prev => ({
                ...prev,
                company_id: department.company_id,
            }));
        }

        if (department) {
            setPolicies([]);
            getProceduresFN(department.department_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [department]);


    const handleChange = (data) => {
        ////////console.log(data);
        setFormState(data);
        //updateServerData(data, department.department_id, "department");
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    // const updateServerData = useCallback(
    //     debounce((data, department_id, type) => {
    //         // Make your API call here
    //         //alert(action_id);
    //         setIsLoading(true);
    //         updateDepartmentFN(department_id, data);

    //         //alert("Sending data to server!!");
    //         // axios.post("/update-data", data); 
    //     }, 1500), // Adjust the debounce delay (1000 ms = 1 second)

    //     []
    // );


    useEffect(() => {
        if (department) {
            //let this_department = department.find(department => department.department_id === department.department_id);
            ////////console.log(1, department);

            setPolicies(department.policies);

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [department]);

    //const [addedNew, setAddedNew] = useState(false);




    const handleChangePolicy = (data, policy_id) => {

        // ////////console.log(data);
        setFormControlState(data);

        //update the control details by control_id instead of index 
        let updatedPolicy = data.find(policy => policy.policy_id === policy_id);
        updateServerData2(updatedPolicy, department.department_id, "policy", policy_id);


    };


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const updateServerData2 = useCallback(
        debounce((data, department_id, type, policy_id) => {
            // Make your API call here
            //alert(action_id);
            setIsLoading(true);
            editProcedureFN(department_id, policy_id, data);



            //alert("Sending data to server!!");
            // axios.post("/update-data", data); 
        }, 1500), // Adjust the debounce delay (1000 ms = 1 second)
        []
    );


    useEffect(() => {
        if (department_redux) {
            //////////console.log(department_redux);
            let this_department = department_redux.find(departmentx => departmentx.department_id === department.department_id);
            //////////console.log(2, this_department);

            /* if (this_department && this_department.policies && addedNew) {
                 //alert(1);
                 setPolicies(this_department.policies);
             }*/
            setFormControlState([]);
            this_department && this_department.policies.map(policy => {


                let newpolicy = {
                    ...policy,
                    //policy_details: newpolicy_details
                };

                return setFormControlState(prevState => [...prevState, newpolicy]);

            });


            //setFormState(department_redux);
            setIsLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [department_redux]);




    const frameworkOptions = useMemo(
        () => [
            { value: 1, label: t("riskCenterPortal.enums.framework.internal") },
            { value: 0, label: t("riskCenterPortal.enums.framework.operational") },
            { value: 2, label: t("riskCenterPortal.enums.framework.compliance") },
        ],
        [t]
    );

    return (
        <Disable disabled={isLoading}>
            <div className="w-[820px]">
                <div className="p-6 bg-white rounded-xl shadow-2xl border border-gray-200">
                    {/* Header */}
                    <div className="flex justify-between items-start mb-4">
                        <div>
                            <h1 className="text-[18px] font-semibold text-[#1f1f1f]">
                                {formState?.name === "New Department"
                                    ? t("riskCenterPortal.departmentModal.addTitle")
                                    : t("riskCenterPortal.departmentModal.editTitle")}
                            </h1>
                            <p className="text-[12px] text-gray-500 mt-1">
                                {t("riskCenterPortal.departmentModal.subtitle")}
                            </p>
                        </div>

                        <button
                            className="w-8 h-8 rounded-md hover:bg-gray-100 flex items-center justify-center"
                            onClick={() => close(department.department_id, formState)}
                            title={t("riskCenterPortal.departmentModal.close")}
                        >
                            <span className="text-gray-500 text-xl leading-none">×</span>
                        </button>
                    </div>

                    {/* Company display (read-only) */}
                    <div className="mb-4">
                        <label className="block text-[12px] font-semibold text-gray-700 mb-1">
                            {t("riskCenterPortal.departmentModal.company")}
                        </label>

                        <div className="h-10 px-3 flex items-center rounded-md border border-gray-200 bg-gray-50 text-sm text-gray-700">
                            {department?.company_title || department?.company_name || t("riskCenterPortal.departmentModal.unassigned")}
                        </div>

                        {/* if you have company color */}
                        {/* <div className="mt-2 flex items-center gap-2 text-[12px] text-gray-500">
            <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: department?.company_color || "#9CA3AF" }} />
            <span>{department?.company_title || "Unassigned"}</span>
          </div> */}
                    </div>

                    {/* Name */}
                    <div className="mb-4">
                        <label className="block text-[12px] font-semibold text-gray-700 mb-1">
                            {t("riskCenterPortal.departmentModal.departmentName")}
                        </label>

                        <input
                            type="text"
                            placeholder={t("riskCenterPortal.departmentModal.departmentNamePlaceholder")}
                            className="w-full h-10 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300 text-sm"
                            value={formState.name || ""}
                            onChange={(e) => handleChange({ ...formState, name: e.target.value })}
                            name="name"
                        />
                    </div>

                    {/* Definition */}
                    <div className="mb-4">
                        <label className="block text-[12px] font-semibold text-gray-700 mb-1">
                            {t("riskCenterPortal.departmentModal.definition")}
                        </label>

                        <textarea
                            placeholder={t("riskCenterPortal.departmentModal.definitionPlaceholder")}
                            className="w-full min-h-[90px] px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300 text-sm resize-none"
                            value={formState.definition || ""}
                            onChange={(e) => handleChange({ ...formState, definition: e.target.value })}
                            name="definition"
                        />
                    </div>

                    {/* Row: Location / Risk Appetite / Color / Framework */}
                    <div className="grid grid-cols-4 gap-3 mb-2">
                        {/* Location */}
                        <div>
                            <label className="block text-[12px] font-semibold text-gray-700 mb-1">
                                {t("riskCenterPortal.departmentModal.location")}
                            </label>
                            <input
                                type="text"
                                placeholder={t("riskCenterPortal.departmentModal.locationPlaceholder")}
                                className="w-full h-10 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300 text-sm"
                                value={formState.location || ""}
                                onChange={(e) => handleChange({ ...formState, location: e.target.value })}
                                name="location"
                            />
                        </div>

                        {/* Risk Appetite */}
                        <div>
                            <label className="block text-[12px] font-semibold text-gray-700 mb-1">
                                {t("riskCenterPortal.departmentModal.riskAppetite")}
                            </label>
                            <Select
                                options={listRiskAppetites}
                                placeholder={t("riskCenterPortal.departmentModal.riskAppetitePlaceholder")}
                                onChange={(e) => handleChange({ ...formState, risk_appetite: e.value })}
                                styles={customStyles}
                                components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                value={listRiskAppetites.find(r => r.value === formState.risk_appetite)}
                                className="my-custom-select"
                                classNamePrefix="my-custom-select"
                            />
                        </div>

                        {/* Color */}
                        <div>
                            <label className="block text-[12px] font-semibold text-gray-700 mb-1">
                                {t("riskCenterPortal.departmentModal.color")}
                            </label>
                            <Select
                                options={department_colors}
                                placeholder={t("riskCenterPortal.departmentModal.colorPlaceholder")}
                                onChange={(e) => handleChange({ ...formState, color: e.value })}
                                styles={customStyles}
                                components={{ Option: probabilityOption, SingleValue: probabilitySingleValue }}
                                value={department_colors.find(c => c.value === formState.color)}
                                className="my-custom-select"
                                classNamePrefix="my-custom-select"
                            />
                        </div>

                        {/* Framework (required) */}
                        <div>
                            <label className="block text-[12px] font-semibold text-gray-700 mb-1">
                                {t("riskCenterPortal.departmentModal.framework")} <span className="text-red-500">*</span>
                            </label>

                            <select
                                className="w-full h-10 px-3 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:ring-2 focus:ring-gray-300"
                                value={
                                    formState.framework === null || formState.framework === undefined
                                        ? 0
                                        : Number(formState.framework)
                                }
                                onChange={(e) =>
                                    handleChange({
                                        ...formState,
                                        framework: Number(e.target.value),
                                    })
                                }
                                name="framework"
                                required
                            >
                                {frameworkOptions.map((o) => (
                                    <option key={o.value} value={o.value}>
                                        {o.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Existing policies table stays the same */}
                    {formControlState && formControlState?.length > 0 && (
                        <div className="mt-6 table w-full border border-gray-200 rounded-xl overflow-hidden">
                            <div className="table-row bg-gray-50">
                                <div className="table-cell p-4 border-b border-gray-200 font-semibold text-sm text-gray-700">
                                    {t("riskCenterPortal.departmentModal.policiesNumber")}
                                </div>
                                <div className="table-cell p-4 border-b border-gray-200 font-semibold text-sm text-gray-700">
                                    {t("riskCenterPortal.departmentModal.policiesDetails")}
                                </div>
                                <div className="table-cell p-4 border-b border-gray-200 font-semibold text-sm text-gray-700">
                                    {t("riskCenterPortal.departmentModal.policiesAttachment")}
                                </div>
                            </div>

                            {formControlState.map((policy) => (
                                <div key={policy.policy_id} className="table-row bg-white">
                                    <div className="table-cell p-4 border-b border-gray-200">
                                        <span className="font-semibold text-sm text-gray-800">
                                            {policy.policy_no}
                                        </span>
                                    </div>

                                    <div className="table-cell p-4 border-b border-gray-200">
                                        <input
                                            type="text"
                                            value={formControlState.find(c => c.policy_id === policy.policy_id)?.policy_details || ""}
                                            className="w-[250px] p-2 border border-gray-200 rounded-md text-sm"
                                            onChange={(e) => {
                                                const policy_id = policy.policy_id;
                                                const updatedPolicies = [...formControlState];
                                                const policyToUpdate = updatedPolicies.find(p => p.policy_id === policy_id);
                                                if (policyToUpdate) policyToUpdate.policy_details = e.target.value;
                                                handleChangePolicy(updatedPolicies, policy_id);
                                            }}
                                        />
                                    </div>

                                    <div className="table-cell p-4 border-b border-gray-200">
                                        <button
                                            onClick={() => handleAttachmentClick(policy)}
                                            className="text-sm text-blue-600 hover:underline"
                                        >
                                            {policy.policy_attachment
                                                ? t("riskCenterPortal.departmentModal.viewAttachment")
                                                : t("riskCenterPortal.departmentModal.noAttachment")}
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                    />
                </div>
            </div>
        </Disable>
    );

};



const mapStateToProps = (state) => {
    return {
        department_redux: state.department.policies
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateDepartmentFN: (department_id, data) => dispatch(updateDepartment(department_id, data)),
        addProcedureFN: (department_id, data) => dispatch(addProcedure(department_id, data)),
        addAttachmentFN: (department_id, policy_id, file) => dispatch(addAttachment(department_id, policy_id, file)),
        editProcedureFN: (department_id, policy_id, policy) => dispatch(editProcedure(department_id, policy_id, policy)),
        getProceduresFN: (department_id) => dispatch(getProcedures(department_id))
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(DepartmentOverlay);